// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import loadAutoDeliveryOrders from "@guestsupply/App/Handlers/AutoDelivery/loadAutoDeliveryOrders";
import updateAutoDeliveryParameter from "@guestsupply/App/Handlers/AutoDelivery/UpdateAutoDeliveryParameterHandler";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import {
    AutoDeliveryPageContext,
    getAutoDeliveryOrdersDataView,
} from "@guestsupply/App/Store/Selectors/AutoDeliverySelectors";
import { xIsAuthenticated } from "@guestsupply/App/Store/Selectors/GeneralSelectors";
import Modals from "@guestsupply/Overrides/Components/Modals";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        autoDeliveryDataView: getAutoDeliveryOrdersDataView(state, state.xAutoDelivery.parameter!),
        autoDeliveryParameter: state.xAutoDelivery.parameter,
        isAuthenticated: xIsAuthenticated(state),
    };
};

const mapDispatchToProps = {
    loadAutoDeliveryOrders,
    updateAutoDeliveryParameter,
};
type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;
const AutoDeliveryPage = ({
    id,
    autoDeliveryDataView,
    autoDeliveryParameter,
    loadAutoDeliveryOrders,
    updateAutoDeliveryParameter,
    isAuthenticated,
}: Props) => {
    const history = useHistory();

    if(!isAuthenticated){
        history.push("/NotFoundErrorPage");
    }

    React.useEffect(() => {
        if (!autoDeliveryDataView.value && !autoDeliveryDataView.isLoading) {
            loadAutoDeliveryOrders(autoDeliveryParameter || {});
        } else if (
            !autoDeliveryDataView.isLoading &&
            autoDeliveryDataView.value?.length === 0 &&
            autoDeliveryParameter?.page
        ) {
            updateAutoDeliveryParameter({ page: autoDeliveryParameter.page - 1 });
        }
    });

    React.useEffect(() => {
        if (autoDeliveryParameter && Object.keys(autoDeliveryParameter).length) {
            loadAutoDeliveryOrders(autoDeliveryParameter);
        }
    }, []);

    return (
        <Page data-test-selector="AutoDeliveryPage">
            <AutoDeliveryPageContext.Provider value={autoDeliveryDataView}>
                <Zone contentId={id} zoneName="Content" />
                <Modals />
            </AutoDeliveryPageContext.Provider>
        </Page>
    );
};
const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProductContext(AutoDeliveryPage)),
    definition: {
        displayName: "Auto Delivery",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [],
    },
};
export default pageModule;
